export default {
    '网络异常，请稍后再试！': '网络异常，请稍后再试！'
}
